import { FILTER_CHANGE, INCIDENT_REQUEST_ASYNC, PAGINATE_CHANGE } from './constants'

const fetchIncident = (incidentId, reportType) => ({
  type: INCIDENT_REQUEST_ASYNC.INITIATE,
  payload: { incidentId, reportType },
})
export const fetchIncidentSuccess = (data) => ({
  type: INCIDENT_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchIncidentError = (error) => ({
  type: INCIDENT_REQUEST_ASYNC.ERROR,
  error,
})
const fetchIncidentCancel = () => ({ type: INCIDENT_REQUEST_ASYNC.CANCEL })

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
const filterChange = (filterType, newValue) => ({
  type: FILTER_CHANGE,
  payload: { filterType, newValue },
})

export default {
  // to props
  fetchIncident,
  fetchIncidentCancel,
  paginateChange,
  filterChange,
}
